import { Routes, Route, useParams } from 'react-router-dom';
import { LandingPage } from './components/LandingPage';
import { GamePage } from './components/GamePage';
import './App.css';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/game/:gameId" element={<GamePage />} />
    </Routes>
  );
}

export default App;

